<footer class="sticky-footer bg-white">
    <div class="container my-auto">
        <div class="copyright text-center my-auto">
            <span>All trademarks, logos and names are properties of their respective owners. Copyright © 2024 - All rights reserved.</span>
        </div>
    </div>
</footer>